module.exports = __webpack_public_path__ + "static/img/album5_202601_01.760423f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album5_202601_01.jpg
// module id = 5+1y
// module chunks = 100